import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import React, { FC } from "react";

import { Icon } from "../../icon";
import { HeroSliderItem } from "./types";

export interface HeroSliderTitleProps extends HeroSliderItem {
  index: number;
}

export const HeroSliderTitle: FC<HeroSliderTitleProps> = ({ titleTop, titleBottom, index }) => {
  return (
    <AnimatePresence>
      {titleTop && (
        <motion.div
          key={`title-top-${index}`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ ease: "linear", duration: 0.3 }}
          className={clsx(
            "absolute top-1/2 translate-y-[-110%] lg:max-w-[50%] ml-8 mr-8 lg:ml-[10%]",
            "text-[34px] lg:text-[44px] font-medium"
          )}
        >
          {titleTop}
        </motion.div>
      )}
      {titleBottom && (
        <motion.div
          key={`title-bottom-${index}`}
          initial={{ opacity: 0, x: "-100%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: "100%", transition: { duration: 0.2, ease: "easeOut" } }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className={clsx(
            "absolute ml-8 mr-8 lg:left-[30%] w-auto",
            "text-[60px] sm:text-[70px] lg:text-[90px] font-medium"
          )}
        >
          {titleBottom}
          <Icon icon="long-arrow-down" size={36} className="-rotate-90 ml-5 inline" />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
